(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.factory('SynchronisationExternService', ['$http', SynchronisationExternServiceFn]);


    /* service for requesting sync settings */
    function SynchronisationExternServiceFn($http) {
        var baseUrl = '/api/synchronisationsextern/';

        var service = {
            query: query,
            get: get,
            update: update,
            save: save,
            deactivate: deactivate
        };

        return service;

        /* get all synchronisationExtern */
        function query(all) {
            return $http.get(baseUrl + (all ? all : false)).then(function (response) {
                return response.data;
            });
        }

        /* get synchronisationExtern */
        function get(syncSettingId) {
            return $http.get(baseUrl + syncSettingId).then(function (response) {
                return response.data;
            });
        }

        /* delete synchronisationExtern */
        function deactivate(id) {
            return $http.delete(baseUrl + id).then(function (response) {
                return response.data;
            });
        }

        /* update synchronisationExtern */
        function update(syncSettingId, item) {
            return $http.put(baseUrl + syncSettingId, item).then(function (response) {
                return response.data;
            });
        }

        /* save synchronisationExtern */
        function save(item) {
            return $http.post(baseUrl, item).then(function (response) {
                return response.data;
            });
        }
    }
})();